import Swiper from 'swiper';

import { swiperConfig } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
	const $styleguideSliders = document.querySelectorAll('.swiper--styleguide');

	$styleguideSliders.forEach(($styleguideSlider) => {
		const $next = $styleguideSlider.parentNode.querySelector('.swiper-button-next');
		const $prev = $styleguideSlider.parentNode.querySelector('.swiper-button-prev');
		new Swiper($styleguideSlider, {
			...swiperConfig,
			navigation: {
				addIcons: false,
				nextEl: $next,
				prevEl: $prev
			}
		});
	});

	const $statSliders = document.querySelectorAll('.swiper--stat');

	$statSliders.forEach(($statsSlider) => {
		new Swiper($statsSlider, {
			...swiperConfig,
			slidesPerView: 1,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	});

	const $storiesSliders = document.querySelectorAll('.swiper--stories');

	$storiesSliders.forEach(($storiesSlider) => {
		const $next = $storiesSlider.parentNode.querySelector('.swiper-button-next');
		const $prev = $storiesSlider.parentNode.querySelector('.swiper-button-prev');
		new Swiper($storiesSlider, {
			...swiperConfig,
			navigation: {
				addIcons: false,
				nextEl: $next,
				prevEl: $prev
			}
		});
	});

	const $stepsSliders = document.querySelectorAll('.swiper--steps');

	$stepsSliders.forEach(($stepSlider) => {
		const $next = $stepSlider.parentNode.querySelector('.swiper-button-next');
		const $prev = $stepSlider.parentNode.querySelector('.swiper-button-prev');
		new Swiper($stepSlider, {
			...swiperConfig,
			navigation: {
				addIcons: false,
				nextEl: $next,
				prevEl: $prev
			}
		});
	});

	const $logoSliders = document.querySelectorAll('.swiper--logo');

	$logoSliders.forEach(($logoSlider) => {
		new Swiper($logoSlider, {
			...swiperConfig,
			slidesPerView: 2.5,
			breakpoints: {
				640: {
					slidesPerView: 5,
				},
			},
		});
	});

	const $wideSlideSliders = document.querySelectorAll('.swiper--wide-slide');

	$wideSlideSliders.forEach(($wideSlideSlider) => {
		const $next = $wideSlideSlider.parentNode.querySelector('.swiper-button-next');
		const $prev = $wideSlideSlider.parentNode.querySelector('.swiper-button-prev');
		new Swiper($wideSlideSlider, {
			...swiperConfig,
			navigation: {
				addIcons: false,
				nextEl: $next,
				prevEl: $prev,
			},
			breakpoints: {
				640: {
					slidesPerView: 1.2,
				},
				1024: {
					slidesPerView: 2.2,
				},
			},
		});
	});

	const $personsSliders = document.querySelectorAll('.swiper--persons');

	$personsSliders.forEach(($personsSlider) => {
		const $next = $personsSlider.parentNode.querySelector('.swiper-button-next');
		const $prev = $personsSlider.parentNode.querySelector('.swiper-button-prev');
		new Swiper($personsSlider, {
			...swiperConfig,
			navigation: {
				addIcons: false,
				nextEl: $next,
				prevEl: $prev
			}
		});
	});
});
